import React, { useEffect, useState } from 'react';

import {
  Button,
  Col,
  Form,
  FormGroup,
  Input,
  Label,
  Row,
  Table,
  Modal,
  ModalBody,
  ModalFooter,
  ModalHeader,
} from 'reactstrap';

import ReactTable from 'react-table';
import 'react-table/react-table.css';
import { updateApprovalRequiredOrder, rejectApprovalRequiredOrder } from '../../services/api/get-pharmacy-orders';


export default function StarPharmacyOrder({
  isOpen,
  tableSource,
  getOrdersForApprovals,
  onClose,
  cancelationReasons = [],
}) {
  const [showRejectModal, setShowRejectModal] = useState(false);
  const [selectedCartId, setSelectedCartId] = useState(null);
  const [selectedReasonIndex, setSelectedReasonIndex] = useState('');
  const [comment, setComment] = useState('');
  const [error, setError] = useState(null);
  const onApprovedOrder = (cartId) => () => {
    updateApprovalRequiredOrder(cartId)
      .then((res) => {
        getOrdersForApprovals();
      })
      .catch((err) => {
        console.log('err', err);
      });
  };

  const handleSideEffects = () => {
    setShowRejectModal(false);
    setSelectedReasonIndex('');
    setComment('');
    setSelectedCartId(null);
    setError(null)
  }

  const onConfirmReject = async () => {
    try {
      if (selectedReasonIndex === '') {
        alert('Please select a cancellation reason');
        return;
      }
  
      const reason = cancelationReasons[selectedReasonIndex];
  
      if (reason.requiresText && !comment.trim()) {
        alert('Please enter reason text');
        return;
      }
      const cancelComment = reason.requiresText ? comment.trim() : reason.label;
  
      const rejectResponse = await rejectApprovalRequiredOrder(selectedCartId, cancelComment);
      if(rejectResponse.success){
        handleSideEffects();
      }else if(rejectResponse.message){
        setError(rejectResponse.message);
        return;
      }
      await getOrdersForApprovals();
    } catch (err) {
      handleSideEffects();
    }
  };


  

  const onRejectOrder = (cartId) => async () => {
    try {
      if (cancelationReasons.length > 0) {
        setSelectedCartId(cartId);
        setShowRejectModal(true);
        return;
      }
  
      await rejectApprovalRequiredOrder(cartId);
      await getOrdersForApprovals();
    } catch (err) {
      console.log('err', err);
    }
  };
  
  
  const columns = [
    {
      Header: 'Cart Id ',
      accessor: 'cartId',
    },
    {
      Header: 'Partner ',
      accessor: 'partner',
    },
    {
      Header: 'Patient Name ',
      accessor: 'patientName',
    },
    {
      Header: 'Phone ',
      accessor: 'phoneNumber',
    },
    {
      Header: 'User  Name ',
      accessor: 'userName',
    },
    {
      Header: 'Sponsor ',
      accessor: 'sponsor',
    },
    {
      Header: ' Total Amount ',
      accessor: 'totalAmount',
    },
    {
      Header: ' Actions',

      Cell: (row) => {
        return (
          <button
            className="btn btn-success"
            onClick={onApprovedOrder(row.original.cartId)}
          >
            Approve
          </button>
        );
      },
    },
    {
      Header: ' Actions',

      Cell: (row) => {
        return (
          <button
            className="btn btn-danger"
            onClick={onRejectOrder(row.original.cartId)}
          >
            Reject
          </button>
        );
      },
    }
  ];

  return (
    <>

    <Modal
      isOpen={isOpen}
      style={{ maxWidth: '1200px', width: '100%', borderRadius: '4px' }}
    >
      <ModalHeader style={{ backgroundColor: '#8752CC' }} toggle={onClose}>
        <h3
          className="text-center"
          style={{ color: '#fff', fontWeight: 'bold' }}
        >
          Orders For Approval
        </h3>
      </ModalHeader>
      <ModalBody>
        <ReactTable data={tableSource} columns={columns} pageSize={20} />
      </ModalBody>
    </Modal>
      <Modal isOpen={showRejectModal} >
        <ModalHeader toggle={() => { handleSideEffects() }}>
          Reject Order
        </ModalHeader>

        <ModalBody>
          <Label>Cancellation Reason</Label>
          <Input
            type="select"
            value={selectedReasonIndex}
            onChange={(e) => {
              setSelectedReasonIndex(e.target.value);
              setComment('');
            }}
          >
            <option value="">Select reason</option>
            {cancelationReasons.map((reason, index) => (
              <option key={reason.label} value={index}>
                {reason.label}
              </option>
            ))}
          </Input>

          {selectedReasonIndex !== '' &&
            cancelationReasons[selectedReasonIndex]?.requiresText && (
              <>
                <Label className="mt-3">Comment</Label>
                <Input
                  type="textarea"
                  maxLength={255}
                  value={comment}
                  onChange={(e) => setComment(e.target.value)}
                  placeholder="Enter reason (max 255 characters)"
                />
                <small className="text-muted">
                  {comment.length}/255
                </small>
              </>
            )}
          {error && <p className="text-danger mt-2">{error}</p>}
        </ModalBody>

        <ModalFooter>
          <Button color="secondary" onClick={() => handleSideEffects()}>
            Cancel
          </Button>
          <Button color="danger" onClick={onConfirmReject}>
            Reject Order
          </Button>
        </ModalFooter>
      </Modal>

    </>
  );
}
